import type { AttachTaskCreator } from "../lib/attachTask";
import styles from "./AttachTaskChrome.module.scss";

interface AttachTaskChromeProps {
  step: 1 | 2;
  selectedCount: number;
  creators: AttachTaskCreator[];
  stepTwoLabel?: string;
}

export function AttachTaskChrome({
  step,
  selectedCount,
  creators,
  stepTwoLabel = "Task",
}: AttachTaskChromeProps) {
  const preview = creators.slice(0, 3);
  const extraCount = Math.max(0, selectedCount - preview.length);

  return (
    <>
      <div className={styles.stepper}>
        <div className={styles.stepItem}>
          <span
            className={`${styles.stepBadge} ${
              step === 1 ? styles.stepBadgeActive : styles.stepBadgeDone
            }`}
          >
            {step > 1 ? "✓" : "1"}
          </span>
          <span className={step === 1 ? styles.stepLabelActive : styles.stepLabel}>
            Deliverable
          </span>
        </div>
        <div className={styles.stepLine} />
        <div className={styles.stepItem}>
          <span
            className={`${styles.stepBadge} ${
              step === 2 ? styles.stepBadgeActive : styles.stepBadgeIdle
            }`}
          >
            2
          </span>
          <span className={step === 2 ? styles.stepLabelActive : styles.stepLabelIdle}>
            {stepTwoLabel}
          </span>
        </div>
      </div>

      <div className={styles.creatorsBlock}>
        <div className={styles.creatorsLabel}>Creators · {selectedCount}</div>
        <div className={styles.creatorChips}>
          {preview.map((creator) => (
            <span key={creator.id} className={styles.creatorChip}>
              {creator.image ? (
                <img src={creator.image} alt="" className={styles.creatorAvatar} />
              ) : (
                <span className={styles.creatorAvatarFallback} />
              )}
              {creator.name}
            </span>
          ))}
          {extraCount > 0 ? (
            <span className={styles.moreChip}>+{extraCount} more</span>
          ) : null}
        </div>
      </div>
    </>
  );
}
